






import { Component, Vue } from 'vue-property-decorator';
import { Actions } from '@/ts/store/Constants';

@Component
export default class HococoButton extends Vue {
    constructor() {
        super();
    }

    public showShelfMenu() {
        this.$store.dispatch(Actions.SHOW_SHELF);
    }
}
